import { Outlet } from "react-router";
import { AdminShell } from "@/components/layout/admin-shell";
import { useSession } from "@shared/client/session";

/** Cadre de l'admin (la garde de la route garantit une session admin). */
export default function AdminLayout() {
  const session = useSession();
  return (
    <AdminShell email={session?.user.email ?? ""}>
      <Outlet />
    </AdminShell>
  );
}
